module.exports = __webpack_public_path__ + "static/media/logo-full.10a5eaac.svg";